

import { Component, Vue, Prop } from "vue-property-decorator"
import { namespace, Getter, Action, State } from "vuex-class"

// @ts-ignore
import cloneDeep from "lodash/cloneDeep"

import { Team } from "@/types"
import User, { SystemUser } from "@/types/user"
import { Subscription } from "@/types/subscription"

import api from "@/services/api"
import systemApi from "@/services/api/api_System"

// @ts-ignore
import VuePerfectScrollbar from "vue-perfect-scrollbar"

import SkeletonLoader from "@/components/SkeletonLoader.vue"
import DataTable from "@/components/Config/DataTable.vue"
import UserImage from "@/components/UserImage.vue"
import { SystemAudit } from "@/types/audit"

const setup = namespace("setup")

@Component({
	components: {
		"skeleton": SkeletonLoader,
		"scrollbar": VuePerfectScrollbar,
		"data-table": DataTable,
		"user-image": UserImage
	}
})
export default class SystemHistory extends Vue {
	@State public systemUser!: SystemUser

	public users: { [key: string]: SystemUser } = {}
	public audit: SystemAudit[] = []
	public loading: boolean = true;

	/**
	 * On mount, get users page.
	 */
	private async mounted (): Promise<void> {
		this.loading = true

		this.users = (await systemApi.systemUsers()).toDictionary("id")
		this.audit = await systemApi.systemAuditGet()

		this.loading = false
	}

	/**
	 * List of columns for a table
	 */
	public get columns () {
		return [
			{
				key: "changedAt",
				label: "Time",
				hasTemplate: true
			},
			{
				key: "changedBy",
				label: "User",
				hasTemplate: true
			},
			{
				key: "tenantTitle",
				label: "Tenant",
				hasTemplate: true
			},
			{
				key: "text",
				label: "Message",
				hasTemplate: true
			}
		]
	}

	fetchUserPictureUrl (userId: string) {
		return this.users[userId]
			? this.users[userId].pictureUrl
			: "images/blank_user.png"
	}
}

